import {
  Button,
  Callout,
  Flex,
  Grid,
  Heading,
  Table,
  TextField,
  Tooltip,
} from "@radix-ui/themes"
import { useState } from "react"
import BaseApi from "../../../api/api"
import { formatDateTime } from "../../../utils/formatDate"
import { InfoCircledIcon } from "@radix-ui/react-icons"
import { formXlsxFromFlatArray } from "../../../utils/formXlsxFromFlatArray"

export const SamsonReport = () => {
  const [startDate, setStartDate] = useState<string>("")
  const [endDate, setEndDate] = useState<string>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [reportData, setReportData] = useState<
    { skuList: any[]; [key: string]: any }[]
  >([])

  const loadReport = async () => {
    const date_from = startDate && formatDateTime(startDate)
    const date_to = endDate && formatDateTime(endDate)
    if (!date_from) return
    setIsLoading(true)
    try {
      const result = await BaseApi.loadSamsonReport(date_from, date_to)
      if (result?.success) {
        setReportData(result?.report || [])
      }
    } finally {
      setIsLoading(false)
    }
  }

  const downloadReport = () => {
    const flatData = reportData?.flatMap(({ skuList, ...rest }) => {
      return skuList?.map((item) => ({ ...rest, ...item }))
    })
    formXlsxFromFlatArray(
      `samson_${startDate}${endDate ? "_" + endDate : ""}`,
      flatData,
    )
  }

  return (
    <Flex direction="column" justify="center" p="5" gap="4">
      <Heading mb="2" size="4">
        Сформировать отчет по закупкам Самсон ОПТ
      </Heading>
      <Grid width="100%" columns="1fr 3fr" gap="4">
        <Flex direction="column" gap="2">
          <div className="control-group">
            <label htmlFor="start-date">Начальная дата:</label>
            <TextField.Root
              id="start-date"
              type="date"
              size="3"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="control-group">
            <label htmlFor="end-date">
              Конечная дата:
              <Tooltip content="Если оставить конечную дату пустой, то отчет будет сформирован на текущую дату.">
                <InfoCircledIcon width="16" height="16" />
              </Tooltip>
            </label>
            <TextField.Root
              id="end-date"
              type="date"
              size="3"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <Button
            disabled={!startDate || isLoading}
            onClick={() => loadReport()}
          >
            Сформировать отчет
          </Button>
        </Flex>
        <Flex style={{ maxHeight: "50vh" }}>
          <Table.Root>
            <Table.Header>
              <Table.Row>
                <Table.ColumnHeaderCell>Номер</Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>
                  Название документа
                </Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>Клиент</Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>Дата создания</Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>
                  Кол-во товарных позиций в документе
                </Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>Cумма</Table.ColumnHeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {reportData?.map((el) => (
                <Table.Row>
                  <Table.RowHeaderCell>{el.number}</Table.RowHeaderCell>
                  <Table.Cell>{el.name}</Table.Cell>
                  <Table.Cell>{el.clientName}</Table.Cell>
                  <Table.Cell>{el.dateCreate}</Table.Cell>
                  <Table.Cell>{el.skuQuantity}</Table.Cell>
                  <Table.Cell>{el.sum}</Table.Cell>
                </Table.Row>
              )) || (
                <Callout.Root>
                  <Callout.Icon>
                    <InfoCircledIcon />
                  </Callout.Icon>
                  <Callout.Text>Нет данных для отображения.</Callout.Text>
                </Callout.Root>
              )}
            </Table.Body>
          </Table.Root>
        </Flex>
      </Grid>
      {(reportData?.length && (
        <Flex justify="end">
          <Button onClick={downloadReport}>Скачать отчет</Button>
        </Flex>
      )) ||
        null}
    </Flex>
  )
}
